export default __webpack_public_path__ + "static/media/text-bear.1c3725f0.svg";